import { render, staticRenderFns } from "./notiForm.vue?vue&type=template&id=59538fc7&scoped=true"
import script from "./notiForm.vue?vue&type=script&lang=js"
export * from "./notiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59538fc7",
  null
  
)

export default component.exports